import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const KID_LIST_URL = `${API_URL}/api/v1/kid/kid-list`;
export const KID_DEVICES_URL = `${API_URL}/api/v1/parent/kid-devices`;
export const WEB_ACTIVITY_URL = `${API_URL}/api/v1/parent/activity`;
export const APP_WEB_ACTIVITY_URL = `${API_URL}/api/v1/parent/app-web-activity`;
export const SET_RULES_DATA_URL = `${API_URL}/api/v1/parent/set-rules-data`;
export const GET_SLOTS_URL = `${API_URL}/api/v1/parent/slots`;
export const REQUEST_LIST_URL = `${API_URL}/api/v1/parent/request-list`;
export const TIME_SUPERVISION_URL = `${API_URL}/api/v1/parent/time-supervision`;
export const ALL_APP_URL = `${API_URL}/api/v1/parent/all-apps`;
export const ADD_APP_TIME_LIMIT_URL = `${API_URL}/api/v1/parent/app-dailylimit`;
export const DASHBOARD_DATA_URL = `${API_URL}/api/v1/parent/dashboard`;
export const READ_ALERT_URL = `${API_URL}/api/v1/parent/read-alert`;
export const MESSAGE_COUNT_URL = `${API_URL}/api/v1/parent/message-count`;
export const APP_CATEGORIES = `${API_URL}/api/v1/parent/app-categories`;
export const DELETE_ACTIVITY = `${API_URL}/api/v1/parent/delete-activity`;
export const BLOCK_ACTIVITY = `${API_URL}/api/v1/parent/add-website`;
export const LATEST_ACTIVITY_URL = `${API_URL}/api/v1/parent/latest-activity`;
export const SCREEN_TIME_GRAPH_URL = `${API_URL}/api/v1/parent/kids-activity`;
export const DEVICE_SELECTED_URL = `${API_URL}/api/v1/parent/device-selected`;

export function kidList() {
  return axiosInstance({
    url: KID_LIST_URL,
    method: "GET",
  });
}

export function deviceSelected(payload) {
  return axiosInstance({
    url: DEVICE_SELECTED_URL,
    method: "PUT",
    data: payload,
  })
}

export function kidDevices(kidId) {
  return axiosInstance({
    url: KID_DEVICES_URL,
    method: "GET",
    params: { kidId }
  });
}

export function webActivity(payload) {
  return axiosInstance({
    url: WEB_ACTIVITY_URL,
    method: "GET",
    params: payload,
  });
}

export function getWebActivity(payload) {
  return axiosInstance({
    url: WEB_ACTIVITY_URL,
    method: "GET",
    params: payload
  });
}
export function deleteActivity(payload) {
  return axiosInstance({
    url: DELETE_ACTIVITY,
    method: "POST",
    data: payload,
  });
}
export function getAppCategories() {
  return axiosInstance({
    url: `${APP_CATEGORIES}?kidId=7130&deviceId=11940`,
  });
}

export function appWebActivity(payload) {
  return axiosInstance({
    url: APP_WEB_ACTIVITY_URL,
    method: "GET",
    params: payload,
  });
}

export function setRulesDataApi(payload) {
  return axiosInstance({
    url: SET_RULES_DATA_URL,
    method: "GET",
    params: payload,
  });
}

export function getSlots(payload) {
  return axiosInstance({
    url: GET_SLOTS_URL,
    method: "GET",
    params: payload,
  });
}

export function requestList(payload) {
  return axiosInstance({
    url: REQUEST_LIST_URL,
    method: "GET",
    params: payload,
  });
}

export function timeSupervision(payload) {
  return axiosInstance({
    url: TIME_SUPERVISION_URL,
    method: "POST",
    data: payload,
  });
}

export function getAllApps(payload) {
  return axiosInstance({
    url: ALL_APP_URL,
    method: "GET",
    params: payload,
  });
}

export function addAppTime(payload) {
  return axiosInstance({
    url: ADD_APP_TIME_LIMIT_URL,
    method: "POST",
    data: payload,
  });
}

export function dashboardData() {
  return axiosInstance({
    url: DASHBOARD_DATA_URL,
    method: "GET",
  });
}

export function updateDashboardData(payload) {
  return axiosInstance({
    url: READ_ALERT_URL,
    method: "POST",
    data: payload,
  });
}

export function getMessageCount(payload) {
  return axiosInstance({
    url: MESSAGE_COUNT_URL,
    method: "GET",
    params: payload,
  });
}

export function blockActivity(payload) {
  return axiosInstance({
    url: BLOCK_ACTIVITY,
    method: "POST",
    data: payload,
  });
}
export function getLatestActivity(payload) {
  return axiosInstance({
    url: LATEST_ACTIVITY_URL,
    method: "GET",
    params: payload,
  });
}
export function getScreenTime(payload) {
  return axiosInstance({
    url: SCREEN_TIME_GRAPH_URL,
    method: "GET",
    params: payload,
  });
}
